// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { getSettingsCollection } from "@stoneage/App/Store/Selectors/SettingsSelectors";
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import * as React from "react";
import { shallowEqual } from "react-redux";

const ExternalScripts = () => {
    const containerRef = React.useRef<HTMLDivElement>(null);
    const { easyLinkScriptSourceURL } = useAppSelector(
        state => ({
            easyLinkScriptSourceURL: getSettingsCollection(state).customSettings.easyLinkScriptSourceURL,
        }),
        shallowEqual,
    );

    const { isEditing } = useShellContext();

    React.useEffect(() => {
        const container = containerRef.current;

        if (!container || !easyLinkScriptSourceURL || isEditing) {
            return;
        }

        const script = Object.assign(document.createElement("script"), {
            type: "text/javascript",
            src: easyLinkScriptSourceURL,
            async: false,
            defer: true,
        });

        container.appendChild(script);

        return () => {
            container.removeChild(script);
        };
    }, [easyLinkScriptSourceURL]);

    return <div ref={containerRef} className="easyLing" />;
};

export default ExternalScripts;
